var SCM = SCM || {};
SCM.JumpLinks = SCM.JumpLinks || {};

SCM.JumpLinks = (function($, stickyToolbarHelper){
    var $body,
        $jumpLinks,
        jumplinkHash = [],
        $jsJumpLinkTargetIds = [],
        ticking = false;

    /**
    * Returns module API
    * @returns {object}
    */
    return {
        init: init,
        registerNotesTocLink: registerNotesTocLink,
        registerFootNotesLink: registerFootNotesLink
    };

    /** used by init() to jump the page to a jumplink target */
    function _jumpToTarget($target) {
        if ($target.length) {
            var targetOffsetTop = getTargetAndToolbarOffset($target);

            $body.animate({
                scrollTop: targetOffsetTop
            }, 400, function () {
                $(window).off('scroll', handleScroll);
                $(window).on('scroll', handleScroll);
            });
        }
    }

    /**
      * Return a jQuery selector for all elements with the specified attribute and attribute value.
      *
      * This method is appropriate to use when the attribute name is sanitized
      * but the attribute value is not.
      *
      * If you trust the value, you might instead run something like
      *         $('[data-legacy-id="' + hrefWithoutHash + '"]');
      */
    function _byAttr(attrName, attrValue) {        
        
        return $('[' + attrName + ']').filter(
            function () {
                var v = $(this).attr(attrName);
                return v === attrValue;
            }
        );
    }

    function init() {
        $body = $('html, body');
        $jumpLinks = $('.js-jumplink, .sectionLink, .js-no-access-jumplink').not('.disable').not('.hide');
        var locationHashId = window.location.hash;


        if (locationHashId != '' && locationHashId != undefined) {
            adjustScrollMarginTop(locationHashId);
        }

        // article and issue
        //
        // Highlight active jumplink on scroll - step 1
        // Load position & associated jumplink for each section/abstract title into a hash-table-like object
        if ($body.hasClass('pg_article') || $body.hasClass('pg_issue')) {
            // jumplinkHash declared above so we can use it here & in on('scroll') block
            $jumpLinks.each(function(){
                var $this = $(this),
                    $jumplinkTarget = findJumplinkTarget($this.attr('href'));

                jumplinkHash.push({
                    jumplink: $this,
                    target: $jumplinkTarget
                });

            });

            if (locationHashId) {
                var targetIdValue = locationHashId.split('#').pop().trim();
                var indexOfEqual = targetIdValue.indexOf('=');
                if (indexOfEqual > 0) {
                    targetIdValue = targetIdValue.substring(0, indexOfEqual);
                }

                var $target = findJumplinkTarget('#' + targetIdValue);
                _jumpToTarget($target);               
            }

            $(window).on('scroll', handleScroll);
            registerFootNotesLink();
        }

        // chapters
        if ($body.hasClass('pg_chapterstandard')) {
            // jumplinkHash declared above so we can use it here & in on('scroll') block
            $jumpLinks.each(function () {
                var $this = $(this);
                var targetIdValue = $($this.attr('href').split('#').pop().trim());
                $target = findJumplinkTarget('#' + targetIdValue.selector);
                var $jumplinkTarget = findJumplinkTarget($target);

                jumplinkHash.push({
                    jumplink: $this,
                    target: $jumplinkTarget
                });

            });

            // NARN-17126 support jumping to first data supplement reference
            //            .. in lieu of something representing the data supplement!
            //            (WHY?  Because in Dec 2020 we don't show data supplements on the page, just links to them.)
            if (locationHashId) {
                targetIdValue = locationHashId.split('#').pop().trim();
                if (targetIdValue.startsWith('jumplink-')) {
                    targetIdValue = targetIdValue.substr('jumplink-'.length);
                    $target = _byAttr('data-supplement-target', targetIdValue);
                    _jumpToTarget($target);
                }                
            }

            $(window).on('scroll', handleScroll);
            registerFootNotesLink();
        }

        if ($body.hasClass('pg_siconversioncalculatorpage')) {
            $(window).on('scroll', handleScroll);
        }
        
        registerTocJumpLinkClickEvents($body, $jumpLinks);

        // changes for splitview
        if ($body.hasClass('pg_articlesplitview')) {
            // hide References jumplink in Contents tab
            $('.js-jumplink:contains("References")').parents('.section-jump-link').hide();
        }
    }
    
    function getTargetAndToolbarOffset($target) {
        var toolbarHeight = stickyToolbarHelper.getStickyToolbarHeight();
        var targetId = $target[0].id;
        // Special cases for 'Get Access' jumplinks: add 18px of space
        if (targetId == 'no-access-message' || targetId == 'login-purchase') {
            return $target.offset().top - toolbarHeight - 18;
        }
        else {
            return $target.offset().top - toolbarHeight;
        }
    }

    /**
    * Differentiate between jumplink targeting id attr vs data-legacy-id attr
    * @param targetID {string}
    * @return $target {object}
    */
    function findJumplinkTarget(targetID) {
        if (targetID && targetID.length) {
            var $target = $(targetID);

            if ($target.length === 0 && targetID.startsWith('#')) {
                var hrefWithoutHash = targetID.substring(1);
                var $dataLegacyTarget = $('[data-legacy-id="' + hrefWithoutHash + '"]');
                var $contentTarget = $('[content-id="' + hrefWithoutHash + '"]');
                $target = $dataLegacyTarget.length !== 0 ? $dataLegacyTarget : $contentTarget;
            }
            return $target;
        }
        return null;
    }

    /**
    * Handle window scroll, and capture current scroll position Y
    */
    function handleScroll() {
        lastScrollPosY = window.scrollY;
        requestTick();
    }
    /**
    * Request new rAF if not active
    */
    function requestTick() {
        if (!ticking) {
            rAF = requestAnimationFrame(highlightOnScroll);
            ticking = true;
        }
    }


    /**
    * register click event for manually added notes link on TOC
    * this is added after chapter display, if end notes widget exists
    */
    function registerNotesTocLink(notesDiv, eventClassName) {
        $('.' + eventClassName).on('click', function () {           
            var targetOffsetTop = $(notesDiv).offset().top - 50;
            $body.animate({
                scrollTop: targetOffsetTop
            }, 400, function () {
                $(window).off('scroll', handleScroll);
                $(window).on('scroll', handleScroll);
            });
            $body.removeClass('noscroll');
        });
    }

    function registerTocJumpLinkClickEvents($body, $jumpLinks) {
        $jumpLinks.on('click', function (e) {
            if ($body.hasClass('pg_issue')) {
                let searchParams = new URLSearchParams(window.location.search);
                handlePageNumberInJumplink($(e.target), searchParams);
            }
            else if ($body.hasClass('pg_article') || $body.hasClass('pg_chapterstandard') || $body.hasClass('pg_siconversioncalculatorpage')) {
                findAndScrollToTarget($body, $(this).attr('href'));

                closeMobileNavModal($body);

                $(document).off('touchmove');
                SCM.SiteJS.initFoundation();
            }
            else if ($body.hasClass('pg_book')) {
                findAndScrollToTarget($body, $(this).attr('href'));
            }
        });
    }

    function handlePageNumberInJumplink($link, searchParams) {
        let pageNumberParam = searchParams.get('page');
        var page = 1;
        if (pageNumberParam) {
            page = Number.parseInt(pageNumberParam);
        }

        if ($link.data('page') !== 0 && $link.data('page') !== page) {
            window.location = '?page=' + $link.data('page') + $link.attr('href');
        }
    }

    function adjustScrollMarginTop(scrollTarget) {
        var $target = $(scrollTarget);

        if ($target.length) {
            var toolbarHeight = stickyToolbarHelper.getStickyToolbarHeight();
            $target.css('scroll-margin-top', toolbarHeight + 'px');
        }
    }

    function findAndScrollToTarget($body, href) {
        var $target = findJumplinkTarget(href);

        var targetOffsetTop = getTargetAndToolbarOffset($target);

        $body.animate({
            scrollTop: targetOffsetTop
        }, 400, function () {
            $(window).off('scroll', handleScroll);
            $(window).on('scroll', handleScroll);
        });
    }

    function closeMobileNavModal($body) {
        $('.page-column--left').removeClass('js-filters-open');
        $('.page-column--left, .responsive-issue-nav, .issue-dropdown-wrap').removeAttr('style');
        $body.removeClass('noscroll');
    }

    function getContentBody($el) {
        if ($('.js-sv-main:visible').length) { // split view
            // special case for footnotes in tables or figures - they are in a different pane in split view
            if (($el.closest('.table-wrap-foot').length || $el.closest('.js-fig-section').length) && 
                $('.js-sv-figuresTables').length) {
                return $('.js-sv-figuresTables');
            }
            return $('#split-view-scroll-pane');
        } else {
            return $('#ContentColumn');
        }
    }

    function registerFootNotesLink() {
        $('.js-end-note-link').off('click');  // unbind event when switching between split view and standard view
        $('.js-end-note-link').on('click', function () {
            var footnoteId = $(this).attr('data-fn-id');
            var bookId = $('#bookId').val();
            var isArticle = $('.widget-ArticleFulltext').length > 0;
            var $contentBody = getContentBody($(this));
            var isSplitView = $('.js-sv-main:visible').length;
            if (footnoteId && footnoteId.length) {
                var $noteLink;
                if (isArticle) {
                    $noteLink = $('.content-inner-wrap:visible .js-xref-fn[reveal-id="' + footnoteId + '"]:visible');
                    // special case for table-modals that are marked display:block and visibility:hidden
                    // Have to filter those out and only look at ones not in the modal
                    if ($noteLink.length > 1) {
                        $noteLink = $noteLink.filter(function (idx) {
                            var $parent = $($noteLink[idx]).closest('.table-modal.table-full-width-wrap');
                            return $parent.length === 0;
                        });
                        $noteLink = $noteLink.first();
                    }
                }
                else {
                    $noteLink = $contentBody.find('.js-xref-fn[reveal-id="' + footnoteId + '"]:first');
                }
                if ($noteLink.length === 0 && bookId.length) {
                    // If it's on this page don't need 
                    // to find the chapter on the server side
                    // 2 types of links - footnote links and xref links - check both
                    $noteLink = $contentBody.find('.js-related-object[legacysectionid="' + footnoteId + '"]:first');
                }
                if ($noteLink.length) {
                    var pageOffset = 0;
                    var $pageBody = $body;
                    var targetOffsetTop = $noteLink.offset().top - 60;
                    if (isSplitView) {
                        // need to account for sticky toolbar && splitview
                        // have to scroll from a different place in split view
                        pageOffset = $contentBody.offset().top;
                        $pageBody = $contentBody;
                        targetOffsetTop = $noteLink.offset().top - pageOffset + $contentBody.scrollTop() - 5;
                    }
                    $pageBody.animate({
                        scrollTop: targetOffsetTop
                    }, 200, function () {
                        $(window).off('scroll', handleScroll);
                        $(window).on('scroll', handleScroll);
                    });
                    $body.removeClass('noscroll');
                }
                // Don't need to do this for articles, since footnotes will be on the current page
                else if (!isArticle && bookId.length) {
                    var baseUrl = App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '';
                    $.ajax({
                        url: baseUrl + '/Content/GoToChapterFootNote',
                        cache: false,
                        data: {
                            bookId: bookId,
                            footnoteId: footnoteId
                        },
                        dataType: 'json',
                        success: function (response) {
                            if (response.Success) {
                                window.location = response.RedirectURL;
                            }
                        }
                        //if failure, we couldn't find it so do nothing
                    });
                }
            }
        });
    }

    /**
    * Highlight jumplink corresponding to current page section in scroll frame
    */
    function highlightOnScroll() {
        var $jsJumplinks = $('.js-jumplink');
        var searchParams = new URLSearchParams(window.location.search);

        //highlighting on scroll
        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();

            $('.articleClientType').each(function () {
                var topDistance = $(this).offset().top;
                var subheadingArticleId = $(this).attr('id');
                var scrollToLink = $('.section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');

                // if section is in view
                if (topDistance - 90 < scrollTop) {
                    if ($(scrollToLink).length) {
                        $('.list-issue-jumplinks li').removeClass('active');
                    }
                    $('#largeJumptoSection').removeAttr('tabindex');
                    $jsJumplinks.removeClass('active')
                        .removeAttr('aria-current')
                        .attr('tabindex', '-1');
                    $(scrollToLink).closest('.js-jumplink')
                        .addClass('active')
                        .attr('aria-current', 'true')
                        .attr('tabindex', '0');
                }
            });

            if ($body.hasClass('pg_issue') && !$jsJumplinks.hasClass('active')) {
                let pageNumberParam = searchParams.get('page');
                var pageSize = $('#ArticleListPageSize').val();
                var page = 0;
                if (pageNumberParam) {
                    page = Number.parseInt(pageNumberParam) - 1;
                }

                var find = page * pageSize;

                var prev;
                var links = $('.section-jump-link__link-wrap a');
                links.each(function (idx, elem) {
                    if (elem.dataset.ordinal > find) {
                        $(prev).closest('.js-jumplink').addClass('active');
                        return false;
                    } else if (links.length-1 === idx) {
                        $(elem).closest('.js-jumplink').addClass('active'); 
                    }
                    prev = elem;
                });
            }

            if ($('.article-body').length) {
                $('#ContentColumn h2').each(function () {
                    var topDistance = $(this).offset().top;
                    var subheadingArticleId = $(this).attr('id');
                    var scrollToLink = $('#InfoColumn .section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');
                    // if section is in view
                    if (topDistance - 90 < scrollTop) {
                        if ($(scrollToLink).length) {
                            $('.jumplink-list li').removeClass('active');
                        }
                        $jsJumplinks.removeClass('active');
                        $(scrollToLink).closest('.js-jumplink').addClass('active');
                    }
                });
            }

            if ($('.book-chapter-body').length) {
                if (!$jsJumpLinkTargetIds.length) {
                    $('#ContentColumn h2, #ContentColumn h3, #ContentColumn h4').each(function () {
                        $jsJumpLinkTargetIds.push($(this));
                    });
                    // if there is a notes link in the TOC, add the footnotes element as one of the jumplinks
                    if ($('.js-toc-footnotes-link').find('.js-notes-link-chapter-footnotes:visible').length > 0) {
                        $jsJumpLinkTargetIds.push($('#chapter-footnotes'));
                    } // if there is a notes link in the TOC, add the endnotestargetlocation element as one of the jumplinks
                    if ($('.js-toc-notes-link').find('.js-notes-link-end-notes:visible').length > 0) {
                        $jsJumpLinkTargetIds.push($('#endNotesTargetLocation'));
                    }
                }

                $($jsJumpLinkTargetIds).each(function () {
                    var topDistance = $(this).offset().top;
                    var scrollToLink, subheadingChapterId;

                    if ($(this).data('magellan-destination')) {
                        subheadingChapterId = parseInt($(this).data('magellan-destination'));
                    }
                    else {
                        subheadingChapterId = parseInt($(this).prevAll('.jumpLoc-sectionId').eq(0).attr('id'));
                    }

                    // special case for End notes widget link
                    // widget displays when chapter has end notes, we manually add Notes link in TOC to jump to it
                    if ($(this).hasClass('js-end-notes-target')) {
                        scrollToLink = $('#InfoColumn .js-section-title-wrap .js-notes-link-end-notes:visible');
                    }
                    else if ($(this).hasClass('js-footnotes-target')) {
                        scrollToLink = $('#InfoColumn .js-section-title-wrap .js-notes-link-chapter-footnotes:visible');
                    }
                    else {
                        scrollToLink = $('#InfoColumn .js-section-title-wrap a[data-sectionid="' + subheadingChapterId + '"]');
                    }

                    // if section is in view
                    if (topDistance - 120 < scrollTop) {
                        if ($(scrollToLink).length) {
                            $('.jumplink-list[role="tree"]').attr('tabindex', '-1');
                            $('.js-jumplink-list li').removeClass('active');
                            $('.tocLink[aria-current]').removeAttr('aria-current')
                                .attr('tabindex', '-1');
                            $jsJumplinks.removeClass('active at-highlighted-heading');
                            $(scrollToLink).closest('.js-jumplink')
                                .addClass('active at-highlighted-heading')
                                .attr('aria-current', 'true')
                                .attr('tabindex', '0');
                            $(scrollToLink).closest('.js-jumplink').addClass('at-highlighted-heading');
                            $(scrollToLink).parents('.js-headings-placeholder').siblings('.js-section-title-wrap').find('.js-tocLink').addClass('active');
                            $(scrollToLink).parents('.js-headings-placeholder').siblings('.js-section-title-wrap').find('.js-jumplink').addClass('active');
                        }
                    }
                });
            }

            if ($('.pg_siconversioncalculatorpage').length) {
                var $jumpLinkTargets = $('#table1, #length, #area, #mass, #volume, #table2, #analytes__A-D, #analytes__E-K, #analytes__L-Q, #analytes__R-Z');
                $jumpLinkTargets.each(function () {
                    var topDistance = $(this).offset().top;
                    var subheadingId = $(this).attr('id');
                    var scrollToLink = $('#InfoColumn .section-jump-link__link-wrap a[href="#' + subheadingId + '"]');
                    // if section is in view
                    if (topDistance - 90 < scrollTop) {
                        if ($(scrollToLink).length) {
                            $('.jumplink-list li').removeClass('active at-selected-LR-element');
                        }
                        $jsJumplinks.removeClass('active at-selected-LR-element');
                        $(scrollToLink).closest('.js-jumplink').addClass('active at-selected-LR-element');
                    }
                });
            }
        });
    }

})(jQuery, SCM.StickyToolbarHelper);